import type { DateWindow } from "@nexus/contracts";
import { parseYmdLocal } from "./ymd";

function formatBound(date: Date, withYear: boolean): string {
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    ...(withYear ? { year: "numeric" } : {}),
  });
}

/** `Jun 3 – Aug 31, 2026` — chart and window copy. */
export function formatDashboardWindow(window: DateWindow): string {
  const start = parseYmdLocal(window.startDate);
  const end = parseYmdLocal(window.endDate);
  if (!start || !end) return `${window.startDate} – ${window.endDate}`;
  const sameYear = start.getFullYear() === end.getFullYear();
  return `${formatBound(start, !sameYear)} – ${formatBound(end, true)}`;
}
